const query: string = `#graphql 
  query ($contentIds: String!) {
    loDspSignUp(contentIds: $contentIds) {
      id
      componentTitle
      heroTitle
      heroImageUrl
      signUpButton
      termsAndConditionsFooter
      successMessage
      errorMessage
      subHeader
      incorrectEmailMessage
      duplicateEmailMessage
      experientialEventLinkCtaText
      signUpFieldLabel
    }
  }
`;

export default query;
